import { RootState } from 'store/types';

export const selectUndistributed = (state: RootState) =>
  state.globalNotification.apartaments.undistributed;
